// Shared app constants and small helpers
import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const RECAPTCHA_SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export const LOGO_URL =
  'https://customer-assets.emergentagent.com/job_98b97763-2aa5-481f-bd79-6ac5b60269a2/artifacts/otruqeli_Our%20Soil%20Final%20TM%20Logo.png';

// Extract YouTube video ID from watch, youtu.be, embed, shorts URLs
export const getYouTubeEmbedUrl = (url) => {
  if (!url) return null;
  const patterns = [
    /(?:youtube\.com\/watch\?v=|youtu\.be\/|youtube\.com\/embed\/|youtube\.com\/shorts\/)([\w-]{11})/,
    /youtube\.com\/v\/([\w-]{11})/,
  ];
  for (const pattern of patterns) {
    const match = url.match(pattern);
    if (match) return `https://www.youtube.com/embed/${match[1]}`;
  }
  return null;
};

// Shared axios client (does not set Authorization globally — callers pass headers)
export const apiClient = axios.create({
  baseURL: API,
});
